export default __webpack_public_path__ + "static/sprites-b224ddfe330d525509acdd611f2203ea.svg";